import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formEndorsementLanding_container: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {

			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {

			},
		},
		formEndorsementLanding_titleContainer: {
			display: 'flex',
			flexDirection: 'column',
			marginBottom: theme.spacing(1),
		},
		formEndorsementLanding_title: {
			fontSize: theme.typography.h4.fontSize,
			color: theme.palette.info.main,
			marginBottom: theme.spacing(1),
			fontWeight: theme.typography.fontWeightBold,
		},
		formEndorsementLanding_subtitleContainer: {
			display: 'flex',
		},
		formEndorsementLanding_subtitleIconContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginRight: theme.spacing(1),
		},
		formEndorsementLanding_subtitleIcon: {
			color: theme.palette.info.main,
		},
		formEndorsementLanding_subtitle: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
	});
});

export default useStyles;
